<template>
    <div data-component="TodayViewLinearTableCellTrack"
         class="linear-view-table__cell-session-track"
         :style="localTrackStyle">
        <TodayViewLinearTableCellSession v-for="session in track"
                                         :key="session.ID"
                                         :session="session"
                                         @popover-active="handleChildPopover" />
    </div>
</template>

<script>
import TodayViewLinearTableCellSession from './TodayViewLinearTableCellSession';

export default {
    components: {
        TodayViewLinearTableCellSession,
    },

    props: {
        track: {
            type: Array,
            required: true,
        },
        trackStyle: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            localTrackStyle: this.trackStyle,
        };
    },

    methods: {
        handleChildPopover(isActive) {
            if (isActive) {
                this.localTrackStyle = 'z-index: 99';
                return;
            }
            // Revert to the original calculated style.
            this.localTrackStyle = this.trackStyle;
        },
    },
};

</script>

<style lang="less">
    .linear-view-table__cell-session-track {
        position: relative;
        height: 40px;
        flex-shrink: 0;
    }
</style>
